const angular = require('angular');
var app = angular.module('learn-controllers');

/**
 * Edit Articles Controller
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.controller('editAccessProfile', ['Application', 'Authorization', 'AccessProfiles', 'AccessHelper', '$scope', '$translate', function (Application, Authorization, AccessProfiles, AccessHelper, $scope, $translate) {
  var self = this;
  self.features = Application.features.flags();
  self.authtoken = Authorization.getAuthToken();
  self.user = self.authtoken.user;
  var routeParameters = Application.navigation.getRouteParameters();
  self.editSaved = true;
  self.newProfile = routeParameters.id === 'new' || !routeParameters.id;

  self.allowance = {
    profiles: AccessHelper.isAllowed(['admin', 'settings'], null, ['admin'])
  };

  if (!self.allowance.profiles) {
    Application.navigation.goTo('/explore');
    return;
  }

  self.subInstruction = '';

  self.sections = [
    'details',
    'create',
    'edit',
    'analytics',
    'segmentation',
    'users',
    'assignments',
    'settings'
  ];
  self.getOffset  = function(el) {
    var rect = el.getBoundingClientRect(),
      scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
      scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
  };
  self.sectionIcons = {
    'details': 'write',
    'create': 'plus',
    'edit': 'compose',
    'analytics': 'bar chart',
    'segmentation': 'view',
    'users': 'users',
    'assignments': 'outbox',
    'settings': 'star'
  };

  self.goToSection = function(s){
    var elmOffset = self.getOffset(document.querySelector('.js-' + s));
    window.scroll(0, (elmOffset.top - (document.querySelector('.js-' + s).style.paddingTop) - 190));
  };

  self.sections = [
    "details",
    "create",
    "edit",
    "analytics",
    "segmentation",
    "users",
    "assignments",
    "settings"
  ];
  self.sectionSettings = {};
  self.createSectionSettings = function(){
    for (var s = 0; s < self.sections.length; s++) {
      var currentElm = document.querySelector('.js-' + self.sections[s])
      self.sectionSettings[self.sections[s]] = {
        "dims": self.getOffset(currentElm),
        "height": currentElm.clientHeight,
        "bottom": self.getOffset(currentElm).top + currentElm.clientHeight,
        "active": false
      };
    };
  };
  self.customScrollEvent = function(){
    for(var i = 0; i < self.sections.length; i++){
      if (((window.scrollY + 175) > self.sectionSettings[self.sections[i]].dims.top) && ((window.scrollY + 175) < self.sectionSettings[self.sections[i]].bottom) ){
        self.sectionSettings[self.sections[i]].active = true;
      } else {
        self.sectionSettings[self.sections[i]].active = false;
      }
    }
  };
  var waitForSections = setInterval(function(){
    if(document.querySelector('.js-settings') && self.getOffset(document.querySelector('.js-settings')).top !== 0){
      self.createSectionSettings();
      window.addEventListener('scroll',self.customScrollEvent);
      self.customScrollEvent();
      clearInterval(waitForSections);
    };
  },1000);
  window.addEventListener('resize', self.createSectionSettings);

  var locationChange = $scope.$on('$locationChangeStart', function(event) {
    if (self.editSaved) {
      // Allow the route change to progress
      self.denied = true;
      return;
    }

    // Halt the route change and question the action
    self.navigationPath = {};
    self.navigationPath.targetPath = Application.navigation.getPath();
    self.navigationPath.targetSearch = Application.navigation.getUrlParameters();
    self.navigationPath.targetHash = Application.navigation.getHash();
    event.preventDefault();
    self.showDeparture = true;
    self.onLocationChange = function() {
      locationChange();
      Application.messaging.clearMessages('trackstate');
    };
  });

  var newBlankGroup = function() {
    return {
      departments: [],
      locations: [],
      teams: [],
      org_levels: [],
      grades: []
    }
  };

  var profile = {
    name: '',
    description: '',
    created_by: self.user._id,
    permissions: {
      explore: {
        order_content: true
      },
      admin: {
        content: {
          all_create: true,
          workshops_create: false,
          articles_create: false,
          files_create: false,
          videos_create: false,
          scorm_create: false,
          assessments_create: false,
          tracks_create: false,
          imported_content_create: false,
          presentations_create: false,
          surveys_create: false,

          all_edit: true,
          my_content_edit: false,
          workshops_edit: false,
          articles_edit: false,
          files_edit: false,
          videos_edit: false,
          scorm_edit: false,
          assessments_edit: false,
          tracks_edit: false,
          imported_content_edit: false,
          presentations_edit: false,
          surveys_edit: false,

          all_analytics: true,
          workshops_analytics: false,
          articles_analytics: false,
          files_analytics: false,
          videos_analytics: false,
          scorm_analytics: false,
          assessments_analytics: false,
          tracks_analytics: false,
          imported_content_analytics: false,
          presentations_analytics: false,
          my_content_analytics: false,

          restrict_content_categories: false,
          allowed_categories: [],

          segmentation_group: newBlankGroup(),
          restrict_segmentation_options: false,
          require_segmentation: false,

          restrict_category_options: false,

          assessment_reset: true,
          unarchive_content: true,
          archive_content: true,
          approve_content: true
        },
        users: {
          restricted_access: false,
          view: true,
          add: true,
          edit: true,
          password_reset: true,
          suspend: true,
          bulk_add: false,

          admin_set: true,
          creator_set: true,
          manager_set: true,
          profile_set: true,
          buddy_set: true,
          external_users: true,

          user_group: newBlankGroup(),
        },
        assignments: {
          create: true,
          edit: true,
          view: true,
          archive: true,
          reset: true,
          complete: true,
        },
        journeys: {
          create: true,
          edit: true,
          view: true,
          archive: true,
        },
        overview: true,
        settings: true,
        workflows: true,
        reports: true,
        badges: self.features.badges,
        surveys: self.features.surveys,
      }
    }
  };

  self.showUserRestrictions = function() {
    if (!self.profile || !self.profile.permissions || !self.profile.permissions.admin || !self.profile.permissions.admin.users) {
      return false;
    }
    var users = self.profile.permissions.admin.users;
    var restrictedTypes = ['view', 'add', 'edit', 'password_reset', 'suspend'];
    for (var i = 0; i < restrictedTypes.length; i++) {
      if (users[restrictedTypes[i] + '_restricted']) {
        return true;
      }
    }
    return false;
  };

  self.updateProfile = function() {
    if (!self.profile._id) {
      return;
    }

    if (!self.profile.description) {
      Application.messaging.addMessage({'type': 'error', text: 'Please add a description.', duration: 6});
      return;
    }

    self.updateIndicator = true;

    return AccessProfiles.update({
      subresource: self.profile._id
    }, self.profile).$promise.then(function(article) {
      self.updateIndicator = false;
      Application.messaging.addMessage({type: 'success', text: 'Access Profile Saved!', duration: 5});
      self.editSaved = true;
    }).catch(function(err) {
      console.log('Error in update: ', err);
      Application.messaging.addMessage({type: 'error', text: 'There was an error saving.', duration: 5});
      self.updateIndicator = false;
    });
  };

  self.createProfile = function() {
    if (!self.newProfile || self.profile._id) {
      return;
    }

    if (!self.profile.description) {
      Application.messaging.addMessage({'type': 'error', text: 'Please add a description.', duration: 6});
      return;
    }

    self.updateIndicator = true;
    self.profile.user = self.user._id;
    self.profile.created_by = self.user._id;

    AccessProfiles.create(self.profile).$promise
    .then(function(article) {
      self.updateIndicator = false;
      Application.messaging.addMessage({type: 'success', text: 'Access Profile ' + self.profile.name + ' was created!', duration: 5});
      self.editSaved = true;
      // TODO: Go to user profile Overview
      Application.navigation.goTo('/overview/settings/profiles');
    }).catch(function(err) {
      console.log('Error in update: ', err);
    });
  };

  self.removeAccessProfile = function() {
    self.updateIndicator = true;
    AccessProfiles.delete({subresource: self.profile._id}).$promise
    .then(function(results) {

      self.updateIndicator = false;
      self.showDelete = false;
      Application.messaging.addMessage({type: 'success', text: 'Access Profile removed.', duration: 5});
      self.editSaved = true;
      Application.navigation.goTo('/overview/settings');
    }).catch(function(err) {
      self.editSaved = true;
      self.updateIndicator = false;
      self.showDelete = false;
      Application.messaging.addMessage({type: 'error', text: 'There was an error removing this Access Profile.', duration: 5});
    });
  };

  self.contentSegChange = function(type) {
    var settings = self.profile.permissions.admin.content;
    if (settings.require_segmentation && settings.restrict_segmentation_options) {
      if (type === 'restrict') {
        settings.require_segmentation = false;
      }
      if (type === 'require') {
        settings.restrict_segmentation_options = false;
      }
    }
  };

  self.initialize = function () {
    if (!Authorization.hasValidAuthToken()) {
      if (Application.navigation.isRouteSecure()){
        Application.navigation.goToSignIn();
      }
    }

    if (self.newProfile) {
      self.profile = profile;
      self.startEditWatch();
      return;
    }

    AccessProfiles.get({
      subresource: routeParameters.id,
      fields: 'company,name,description,permissions'
    }).$promise.then(function (data) {
      if (data.company !== self.authtoken.company._id) {
        locationChange();
        Application.navigation.goToHome();
        return;
      }

      self.profile = data;
      
      self.startEditWatch();
    }).catch(function (error) {
      Application.messaging.addMessage({type: 'error', text: self.translations['modules.notifications.unableToFindArticle'], duration: 5});
    });
  };

  self.startEditWatch = function() {
    $scope.$watch('access.profile', function(newVal, oldVal) {
      if (!newVal || newVal === oldVal) {
        return;
      }
      self.editSaved = false;
    }, true);
  };

  $translate([
    'edit.general.notification_fieldsMissing'
  ]).then(function(translations){
    self.translations = translations;
    self.initialize();
  });
}]);
